const getDefaultConclusion = {
  status: 200,
  data: {
    conclusion: 'This is default integral language',
  },
}

export default getDefaultConclusion
